export const ENQUIRY_URL = "enquiry";
export const enquiryByIdUrl = (id) => `enquiry/${id}`;
